import { EDIT_NOTE } from "shared/api";
import { Page, SubmitButton } from "shared/react";
import { callAPI } from "../util/api.js";
import { useItem } from "../util/db.js";
import { CreatorAssertion } from "./CreatorAssertion.js";
import { NoteForm } from "./NoteForm.js";

export function NoteEditPage({ id }: { id: string }): React.ReactElement {
	const note = useItem("note", id).data;
	const { creator } = note;
	return (
		<Page title="Edit note">
			<CreatorAssertion creator={creator} />
			<header>
				<h1>Edit note</h1>
			</header>
			<NoteForm data={note} onSubmit={data => callAPI(EDIT_NOTE, { id, ...data })}>
				<SubmitButton>Save note</SubmitButton>
			</NoteForm>
		</Page>
	);
}
